import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ProjectHelper } from 'src/app/core';

@Component({
  selector: 'content-task-wrapper',
  templateUrl: './content-task-wrapper.component.html',
  styleUrls: ['./content-task-wrapper.component.scss'],
  host: { class: 'content-task-wrapper' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentTaskWrapperComponent implements OnInit {
  @Input() phase?: any;
  @Input() expanded = true;

  count = 0;
  location = 'content';

  constructor(public projectHelper: ProjectHelper) {}

  ngOnInit(): void {
    // TODO Doesnt this phase require Asset Data OR do we get it from somewhere else??
  }

  getActions() {
    if (this.getType() === 'multi') {
      const numberOfChilderen = this.phase?.children.length;
      return this.phase?.children[numberOfChilderen - 1].actions;
    } else if (this.getType() === 'stage') {
      return this.phase.actions;
    } else {
      return {};
    }
  }

  getTask() {
    if (this.getType() === 'multi') {
      return this.phase?.children[0]?.children[0];
    } else if (this.getType() === 'stage') {
      return this.phase?.children[0];
    } else {
      return {};
    }
  }

  getTasks() {
    const type = this.getType();

    if (type === 'multi') {
      this.count = 0;
      this.countMulti();
      return `${this.count} ${this.count > 1 ? 'Tasks' : 'Task'}`;
    } else if (type === 'stage') {
      return `${this.phase?.children?.length} ${this.phase?.children?.length > 1 ? 'Tasks' : 'Task'}`;
    } else if (type === 'content') {
      return `${this.phase?.children?.length} ${this.phase?.children?.length > 1 ? 'Tasks' : 'Task'}`;
    } else {
      return '1 Task';
    }
  }

  countMulti() {
    this.phase.children.forEach((x: any) => {
      this.count += x.children.length;
    });
  }

  getType(): 'multi' | 'task' | 'stage' | 'content' {
    switch (this.phase.type) {
      case 'ProductionMulti':
        return 'multi';
      case 'IdeaStage':
        return 'stage';
      case 'ProductionStage':
        return 'stage';
      case 'ProductionTask':
        return 'task';
      case 'ContentVersion':
        return 'content';
      default:
        throw Error('This is not an acceptable phase type');
    }
  }

  getModuleType(): 'ideation' | 'productions' | undefined {
    if (this.phase?.module) {
      switch (this.phase?.module) {
        case 'Idea': {
          return 'ideation';
        }
        default:
          return 'productions';
      }
    }
    return undefined;
  }
}
